export default __webpack_public_path__ + "static/media/Denil.89f0bb9c.jpg";